var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _vm.$config.exclusiveEventsLandingPageMerchandisingBanner
        ? _c("Banner", {
            attrs: {
              "background-color":
                _vm.$config.exclusiveEventsLandingPageMerchandisingBanner
                  .bannerColor,
              tagline:
                _vm.$config.exclusiveEventsLandingPageMerchandisingBanner
                  .tagline,
              title:
                _vm.$config.exclusiveEventsLandingPageMerchandisingBanner.title
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "filters" }, [
        _c(
          "div",
          { staticClass: "filters__segment-filter" },
          [
            _c("div", { staticClass: "segment-filter__shop-by" }, [
              _vm._v("Shop by ")
            ]),
            _vm._v(" "),
            _c("Tabs", {
              attrs: {
                "default-item": _vm.segmentItems[0],
                items: _vm.segmentItems
              },
              on: {
                "reset-tabs-dropdown": function($event) {
                  _vm.$router.push(_vm.makeSegmentRoute("all"))
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "filters__location-date" }, [
          _c(
            "div",
            { staticClass: "filter filter--locations" },
            [
              _c("span", { staticClass: "icon-location-marker" }),
              _vm._v(" "),
              _c(
                "fx-select",
                {
                  attrs: {
                    "default-option": { label: "Any Location", value: null },
                    "disable-native": true,
                    options: _vm.locations
                  },
                  on: { input: _vm.onLocationIdSelected },
                  model: {
                    value: _vm.locationId,
                    callback: function($$v) {
                      _vm.locationId = $$v
                    },
                    expression: "locationId"
                  }
                },
                [
                  _c("span", {
                    staticClass: "icon-chevron-lg-down",
                    attrs: { slot: "caret" },
                    slot: "caret"
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter filter--date" },
            [
              _c("span", { staticClass: "icon-calendar-blank" }),
              _vm._v(" "),
              _c(
                "fx-date-range",
                {
                  attrs: {
                    align: "left",
                    "data-e2e": "search.date-filter",
                    "min-date": "today",
                    "custom-option-copy": "Choose Date",
                    "default-option-copy": "Any Date",
                    presets: _vm.dateRangeFilterPresets
                  },
                  on: { input: _vm.onDateRangeSelected },
                  model: {
                    value: _vm.dateRange,
                    callback: function($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange"
                  }
                },
                [
                  _c("span", {
                    staticClass: "icon-chevron-lg-down",
                    attrs: { slot: "caret" },
                    slot: "caret"
                  })
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("EventList", {
            attrs: {
              events: _vm.events,
              "filters-applied": Boolean(
                _vm.segment !== "all" || _vm.locationId || _vm.dateRange
              ),
              "format-points": _vm.formatPoints,
              "is-loading-events": _vm.isLoadingEvents,
              "is-loading-more-events": _vm.isLoadingMoreEvents,
              "is-loyalty-pricing": _vm.$store.state.isRedeemingLoyaltyPoints,
              "load-more-copy": "Show More",
              "loading-more-copy": "Loading More Events...",
              "make-event-route": _vm.makeEventRoute,
              pagination: _vm.pagination
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }